import React from 'react';
import bannerImage from '../../../assests/images/card.jpg'
import calender from '../../../assests/images/Vectorcalender.svg'
import {Button, Grid, Typography} from "@material-ui/core";
import {makeStyles, useTheme} from "@material-ui/core/styles";
import moment from "moment";
import EventButton from "../EventButton";
import {getImage} from "../../../utils/image";

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
    },
    sessionImage: {
        maxWidth: '100%',
        display: 'block',
        [theme.breakpoints.down('sm')] : {
            minWidth: 'auto',
            maxWidth: '100%',
            minHeight: 'auto',
            maxHeight: 'none'
        },
        backgroundColor: (theme) => theme.palette.background.default
    },
    sessionContent: {
        textAlign: "left",
        color: (theme) => theme.palette.text.primary,
        backgroundColor: '#191919',
        overflow: 'hidden',
        padding: '16px 12px'

    },
    desc: {
        fontSize: '16px',
        margin: '0 0 12px 0',
        height: '48px'
    },
    button: {
        fontSize: '14px',
        padding: '9px 22px',
        borderRadius: '0',
    },
    timeStamp: {
        fontSize: '14px'
    },
    calendar: {
        display: 'inline-block',
        verticalAlign: 'top',
        marginRight: '15px'
    },
    date: {
        width: 'calc(100% - 39px)',
        display: 'inline-block',
        fontFamily: 'Manrope'
    }
}));

export default function FeaturedSession({ data, toggleModal, videoData, onSubmit }){
    const theme = useTheme();
    const classes = useStyles(theme);

    return <Grid item md={4} xs={12}>
        <div className={classes.sessionImage}>
            <img width={'100%'} height={'auto'} src={getImage(data.image)} alt={data.image}/>
        </div>
        <div className={classes.sessionContent}>
            <Typography component="p" className={classes.desc}>
                {data.title}
            </Typography>
            <Grid container spacing={2}>
                <Grid item xs={12} md={7} className={classes.timeStamp}>
                    <img src={calender} alt="Calendar" className={classes.calendar} /> <Typography component={'span'} className={classes.date}>{`${moment(data.startDate).format("ddd MMM D")}, ${moment(data.startDate).format('h:mma')} - ${moment(data.endDate).format('h:mma')}`}</Typography>
                </Grid>
                <Grid item xs={12} md={5}>
                    <EventButton videoData={videoData} data={data} isFeatured={true} toggleModal={toggleModal} onSubmit={onSubmit} />
                </Grid>
            </Grid>
        </div>
    </Grid>
}